import {ChronoUnit} from "@js-joda/core";
import {TIME_UNITS} from "components/basic/dropdowns/time-unit-dropdown/timeUnits";

export const validateUnitValue = (value: ChronoUnit | string) => {
    if (typeof value === "string") {
        return TIME_UNITS.find(unit => unit.label.toUpperCase() === value)?.value as ChronoUnit
    }
    return value;
}